import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';

type Props = {
  className?: string,
  visible?: boolean,
  isMainBackground?: boolean,
  children?: React.ReactNode

  onClick?: () => void
};

type DefaultProps = Required<Pick<Props, 'isMainBackground'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class ModalBackground extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    isMainBackground: true
  };

  override render (): React.ReactNode {
    const { className, visible, isMainBackground,
      children, onClick
    } = (this.props as PropsWithDefaults);
    
    const modalBackgroundClassNames = classNames(
      className,
      'esko_slideoutbackground',
      {'is-visible': visible}
    );

    if (isMainBackground) {
      if (visible) {
        $('body').addClass('modal-open');
      } else {
        $('body').removeClass('modal-open');
      }
    }

    return (
      <div>
        <div className={modalBackgroundClassNames} onClick={onClick} />
        {children}
      </div>
    );
  }
}

export default ModalBackground;
